/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { QuestionnaireStrictHttpResponse } from '../../questionnaire-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeclineQuestionnaireConsentRequestModel } from '../../models/decline-questionnaire-consent-request-model';
import { QuestionnaireConsentResponseModel } from '../../models/questionnaire-consent-response-model';

export interface ApiConsumerQuestionnaireConsentDeclinePost$Params {
      body?: DeclineQuestionnaireConsentRequestModel
}

export function apiConsumerQuestionnaireConsentDeclinePost(http: HttpClient, rootUrl: string, params?: ApiConsumerQuestionnaireConsentDeclinePost$Params, context?: HttpContext): Observable<QuestionnaireStrictHttpResponse<QuestionnaireConsentResponseModel>> {
  const rb = new RequestBuilder(rootUrl, apiConsumerQuestionnaireConsentDeclinePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as QuestionnaireStrictHttpResponse<QuestionnaireConsentResponseModel>;
    })
  );
}

apiConsumerQuestionnaireConsentDeclinePost.PATH = '/api/consumer/questionnaire/consent/decline';
